/*
 * @Author: v_smwang
 * @Date: 2020-08-01 15:23:49
 * @LastEditors: v_smwang
 * @LastEditTime: 2020-08-02 19:45:53
 * @FilePath: \src\store\modules\personnelWorkHour.js
 * @Description: 描述
 * @Module: 模块路径
 */
const personnelWorkHourDetail = {
  namespaced: true,
  state: {
    formData: {
      // 筛选条件
      start_time: '', // 开始时间
      end_time: '', // 结束时间
      timetype: '', // 统计周期
      outsourcer: '', // 供应商
      exception: '', // 异常情况
      execpeople: '', // 执行人

    },
    inquireNum: 0,
  },

  mutations: {
    UPDATE_FORMDATA: (state, {
      fieldName,
      value,
    }) => {
      state.formData[fieldName] = value;
    },
    UPDATE_ACTIVETABNAME: (state, params) => {
      // 更新tab页，制作还是内检
      state.activeTabName = params;
    },
    // eslint-disable-next-line no-unused-vars
    UPDATE_INQRIRENUM: (state, params) => {
      // 点击查询次数
      state.inquireNum = state.inquireNum + 1;
    },
    UPDATE_SELECTEDROPDOWN: (state, params) => {
      // 更新下拉框
      state.dropDownNum = params;
    },
  },

  actions: {
  },
};

export default personnelWorkHourDetail;
